import React, { useContext } from "react";
import { Table, Tag, Space } from "antd";
import { LanguageContext } from "../../../context/LanguageContext";

export const CriminalcourtcasesTable = (props) => {
  const { t } = useContext(LanguageContext);
  //   const onDeleteMembers = (values) => {
  //     props.onDeleteMembers(values);
  //   };

  const columns = [
    {
      title: t("case_no"),
      dataIndex: "case_no",
      key: "case_no",
    },
    {
      title: t("action"),
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <a>{t("view1")}</a>
        </Space>
      ),
    },
  ];

  return <Table columns={columns} dataSource={props.data} size="small" />;
};
